/*
 * UploadPage Messages
 *
 * This contains all the text for the UploadPage component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.UploadPage.title',
    defaultMessage: 'Upload GPX Files - RunnerMaps',
  },
  description: {
    id: 'app.containers.UploadPage.description',
    defaultMessage: 'Upload multiple GPX files to import them as routes',
  },
  header: {
    id: 'app.containers.UploadPage.header',
    defaultMessage: 'Upload GPX Files',
  },
  intro: {
    id: 'app.containers.UploadPage.intro',
    defaultMessage:
      'Select one or more GPX files. They will be uploaded and imported as new routes one by one.',
  },
  chooseFiles: {
    id: 'app.containers.UploadPage.chooseFiles',
    defaultMessage: 'Choose GPX Files',
  },
  signInRequired: {
    id: 'app.containers.UploadPage.signInRequired',
    defaultMessage: 'You must <a href="#login">sign in</a> first',
  },
  statusPending: {
    id: 'app.containers.UploadPage.statusPending',
    defaultMessage: 'Waiting…',
  },
  statusUploading: {
    id: 'app.containers.UploadPage.statusUploading',
    defaultMessage: 'Uploading…',
  },
  statusSuccess: {
    id: 'app.containers.UploadPage.statusSuccess',
    defaultMessage: 'Imported',
  },
  viewRoute: {
    id: 'app.containers.UploadPage.viewRoute',
    defaultMessage: 'View route',
  },
});
